import React from "react";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
   
    const { usuario } = useContext(AuthContext);
    return usuario ? <Navigate to="/auth/profile" /> : children;
  };

  export default PublicRoute;